var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-drag',{attrs:{"options":_vm.options,"cls":_vm.cls}},[_c('div',{staticClass:"vl-notify-content",style:(_vm.contentStyle),attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }